import { facetOptionSlug } from 'client-portal/utils/clinicianSearch/facet-option-slug';
import { parseTrimmedString } from 'client-portal/utils/clinicianSearch/comma-query-param';

function normalizeApproachName(value) {
  return parseTrimmedString(value);
}

function approachCountByLower(buckets) {
  let countByLower = new Map();

  for (let bucket of buckets) {
    let name = normalizeApproachName(bucket?.key);
    if (name) {
      let lower = name.toLowerCase();
      countByLower.set(lower, (countByLower.get(lower) ?? 0) + Number(bucket.count ?? 0));
    }
  }

  return countByLower;
}

function approachNamesFromRecords(records) {
  let labelByLower = new Map();

  for (let record of records) {
    for (let raw of record?.marketingServices ?? []) {
      let name = normalizeApproachName(raw);
      let lower = name.toLowerCase();
      if (name && !labelByLower.has(lower)) {
        labelByLower.set(lower, name);
      }
    }
  }

  return [...labelByLower.values()].sort((a, b) => a.localeCompare(b));
}

export function buildApproachFacetOptions(records = [], buckets = []) {
  let countByLower = approachCountByLower(buckets);

  return approachNamesFromRecords(records).map(name => ({
    key: name,
    slug: facetOptionSlug(name),
    label: name,
    docCount: countByLower.get(name.toLowerCase()) ?? 0,
  }));
}
